import script from "./AddUserDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserDrawer.vue?vue&type=script&setup=true&lang=js"

import "./AddUserDrawer.vue?vue&type=style&index=0&id=1170c5e3&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1170c5e3"]])

export default __exports__